<template>
    <div class="news-list">
        <a-breadcrumb class="breadcrumb">
            <a-breadcrumb-item>您的位置:</a-breadcrumb-item>
            <a-breadcrumb-item><a href="/AssociationNews/list">學會資訊</a></a-breadcrumb-item>
            <a-breadcrumb-item v-if="categoryId"><a :href="`/AssociationNews/list?CatID=${categoryId}`" v-text="categoryText"></a></a-breadcrumb-item>
            <a-breadcrumb-item v-if="searchText" ><span v-text="`搜索：${searchText}`"></span></a-breadcrumb-item>
        </a-breadcrumb>
        <div class="news-container">
            <div class="news-item" v-for="(news, index) in dataList" :key="index" >
                <div class="row">
                    <div class="category">
                        [<router-link :to="`/AssociationNews/list?CatID=${news.catid}`" v-text="categorys.find(c=>c.value==news.catid).name"></router-link>]
                    </div>
                    <h3 class="title">
                        <router-link :to="`/AssociationNews/details/${news.newsid}`" v-text="news.title"></router-link>
                    </h3>
                </div>
                <span class="time" v-text="news.createdtime.substring(0, 10)"></span>
            </div>
            <split-page v-if="visible" :initData="{pageNo, pageSize, total}" :onPageChanged="onPageChanged"/>
        </div>
        <loading v-if="loading" />
    </div>
</template>

<script>
    import SplitPage from '../../components/SplitPage.vue'
    import Loading from '../../components/Loading.vue'
    export default {
        components: {
            Loading,
            SplitPage,
        },
        props: {
            keyword: null,
        },
        data(){
            return {
                categorys: [
                    {
                        value: '6',
                        name: '學會訊息'
                    },{
                        value: '7',
                        name: '學會課程'
                    },{
                        value: '8',
                        name: '活動預告'
                    },{
                        value: '9',
                        name: '醫學新聞'
                    },{
                        value: '10',
                        name: '健康資訊'
                    }
                ],
                pageNo: 1,
                pageSize: 20,
                total: 0,
                visible: false,
                loading: false,
                searchText: '',
                dataList: [],
                categoryId: null,
                categoryText: '',
                params: []
            }
        },
        mounted: function(){
            this.searchText = this.$route.query.keyword || ''
            this.categoryId = this.$route.query.CatID || ''
            this.categoryText = (this.params.find(d=>d.codeid==this.categoryId) || {}).codedesc
            this.onRefresh()
        },
        methods: {
            onPageChanged: function(page) {
            },
            onRefresh: function() {
                this.loading = true
                this.$store.dispatch('getNewsList', {
                    associationid: 4,
                    catid: this.categoryId || undefined,
                    keyword: this.keyword.trim() || undefined,
                    pageNo: this.pageNo,
                    pageSize: this.pageSize,
                }).then(rs=>{
                    this.loading = false
                    this.dataList = rs.list || []
                    this.total = rs.total || 0
                    this.visible = this.total > 0                    
                }).catch(error=>{
                    this.loading = false
                    this.$message.warning(error)
                })

                this.$store.dispatch('getNewsCategoryList', {
                    associationid: 4,
                }).then(rs=>{
                    this.params = rs || []
                    this.categoryText = (this.params.find(d=>d.codeid==this.categoryId) || {}).codedesc
                })
            }
        },
        watch: {
            '$props.keyword': function(keyword) {
                if(keyword == null) {
                    return
                }
                this.searchText = keyword || ''
                this.categoryId = this.$route.query.CatID || ''
                this.categoryText = (this.params.find(d=>d.codeid==this.categoryId) || {}).codedesc
                this.onRefresh()
            },
            '$route.query.keyword': function(keyword) {
                this.searchText = keyword || ''
                this.categoryId = this.$route.query.CatID || ''
                this.categoryText = (this.params.find(d=>d.codeid==this.categoryId) || {}).codedesc
                this.onRefresh()
            },
            '$route.query.CatID': function(categoryId) {
                this.categoryId = categoryId
                this.searchText = this.$route.query.keyword || ''
                this.categoryText = (this.params.find(d=>d.codeid==categoryId) || {}).codedesc
                this.onRefresh()
            },
        }
    }
</script>

<style scoped>
    .news-list {
        width: 100%;
        display: flex;
        flex-direction: column;
        position: relative;
    }

    .news-list .breadcrumb {
        height: 36px;
        line-height: 36px;
        padding: 0 12px;
        background-color: #fff;
    }

    .news-list .news-container {
        flex: 1;
        background-color: #fff;
        position: relative;
        padding-bottom: 60px;
        display: flex;
        flex-direction: column;
        margin-top: 8px;
        border: 1px solid #e8e8e8;
        box-shadow: 1px 1px 1px #e9e7e7;
    }

    .news-list .news-item {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        height: 44px;
        margin: 0 12px;
        padding: 0 8px;
        cursor: pointer;
        border-bottom: 1px solid #e8e8e8;
        margin-top: 8px;
    }

    .news-list .news-item .row {
        display: flex;
        flex-direction: row;
        flex: 1;
        align-items: center;
        justify-content: flex-start;
        margin-right: 20px;
    }

    .news-list .news-item  .category {
        font-weight: bold;
        line-height: 24px;
        margin-right: 8px;
        color: #0a97f5;
        text-decoration: underline;
    }

    .news-list .news-item .title {
        font-size: 16px;
        font-weight: 400;
        color: #232323;
        line-height: 24px;
        flex: 1;
        margin-right: 20px;
        overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
    }

    .news-list .news-item > .time {
        font-size: 16px;
        font-weight: 400;
        color: #666;
    }
</style>
